const elements = document.querySelectorAll('[data-mime-type][data-size]');

elements.forEach((element) => {
	const size = element.dataset.size;
	const mime = element.getAttribute('data-mime-type');

	let displayedMime = mime.split('/')[1].toUpperCase();
	let displayedSize = parseInt(size);
	let displayedMessage = `${displayedMime}, `;
	if (displayedSize / 1_000 < 1_000)
		displayedMessage += `${(displayedSize / 1_000).toFixed(2)}KB`;
	else if (displayedSize / 1_000_000)
		displayedMessage += `${(displayedSize / 1_000_000).toFixed(2)}MB`;

	element.innerText = displayedMessage;
});

export default elements;
